import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Trans, useTranslation } from 'react-i18next'; 
import "./CenasRomanticasPage.css";


import cenasRomanticasHero from "../../../../../assets/cenas-hero.png";
import cenaPlaya from "../../../../../assets/En la playa.png";
import cenaTipi from "../../../../../assets/Tipi.png";
import palapita from "../../../../../assets/palapita.png";

const CenasRomanticasPage: React.FC = () => {
  
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

 
  const beachIncludes = t('romanticDinnersPage:options.beach.includes', { returnObjects: true }) as string[];
  const tipiIncludes = t('romanticDinnersPage:options.tipi.includes', { returnObjects: true }) as string[];
  const palapitaIncludes = t('romanticDinnersPage:options.palapita.includes', { returnObjects: true }) as string[];

  const safeBeachIncludes = Array.isArray(beachIncludes) ? beachIncludes : [];
  const safeTipiIncludes = Array.isArray(tipiIncludes) ? tipiIncludes : [];
  const safePalapitaIncludes = Array.isArray(palapitaIncludes) ? palapitaIncludes : [];

  return (
    <div className="cenas-romanticas-container">
      
      <header
        className="cenas-hero"
        style={{ backgroundImage: `url(${cenasRomanticasHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title" data-aos="fade-up">
          <Trans i18nKey="romanticDinnersPage:heroTitle" />
        </h1>
      </header>

     
      <section className="info-section" data-aos="fade-up">
        <h2 className="section-title">
          <Trans i18nKey="romanticDinnersPage:sectionTitle" />
        </h2>
        <p className="info-text">
          <Trans 
            i18nKey="romanticDinnersPage:infoText" 
            components={{ strong: <strong /> }}
          />
        </p>
      </section>

      
      <section className="cenas-options">
        <h2 className="section-subtitle" data-aos="fade-up">
          <Trans i18nKey="romanticDinnersPage:optionsSubtitle" />
        </h2>

        
        <div className="cena-item" data-aos="fade-right">
          <div className="cena-img">
            <img src={cenaPlaya} alt="Cena romántica en la playa" />
          </div>
          <div className="cena-details">
            <h3 className="option-name">
              <Trans i18nKey="romanticDinnersPage:options.beach.title" />
            </h3>
            <ul>
              {safeBeachIncludes.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        
        <div className="cena-item reverse" data-aos="fade-left">
          <div className="cena-img">
            <img src={cenaTipi} alt="Cena romántica tipo Tipi" />
          </div>
          <div className="cena-details">
            <h3 className="option-name">
              <Trans i18nKey="romanticDinnersPage:options.tipi.title" />
            </h3>
            <ul>
               {safeTipiIncludes.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="cena-item" data-aos="fade-right">
          <div className="cena-img">
            <img src={palapita} alt="La Palapita" />
          </div>
          <div className="cena-details">
            <h3 className="option-name">
              <Trans i18nKey="romanticDinnersPage:options.palapita.title" />
            </h3>
            <ul>
              {safePalapitaIncludes.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CenasRomanticasPage;